import { shareWX } from '../api/index.js'
import wx from 'weixin-js-sdk'

export default function (shareTitle, postUrl) {
  //如果分享的内容会根据情况变化，那么这里可以传入分享标题及url
  let params = {
    url: window.location.href,
  }
  shareWX(params)
    .then((res) => {
      if (res.code == 0) {
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appid, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
        })

        // 先确认下当前浏览器，接口是否可用
        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          wx.checkJsApi({
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              if (res.checkResult.updateAppMessageShareData) {
                wx.updateAppMessageShareData({
                  title: shareTitle || '广东华兴银行', // 分享标题
                  desc: '广东华兴银行！', // 分享描述
                  link: postUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl:
                    window.location.href.match(/^(http(s)?:\/\/(.*?)\/)/)[1] +
                    'recruit-web/static/wxlogo.jpg', // 分享图标
                  success: function () {
                    // 设置成功
                    alert('分享给朋友设置成功！')
                  },
                  fail: function () {
                    alert('分享失败')
                  },
                  cancel: function () {
                    alert('分享取消')
                  },
                  complete: function () {
                    alert('分享结束')
                  },
                })
              }
              if (res.checkResult.updateTimelineShareData) {
                wx.updateTimelineShareData({
                  title: shareTitle || '广东华兴银行', // 分享标题
                  link: postUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl:
                    window.location.href.match(/^(http(s)?:\/\/(.*?)\/)/)[1] +
                    'recruit-web/static/wxlogo.jpg', // 分享图标
                  success: function () {
                    // 设置成功
                    alert('分享到朋友圈设置成功！')
                  },
                  fail: function () {
                    alert('分享失败')
                  },
                  cancel: function () {
                    alert('分享取消')
                  },
                  complete: function () {
                    alert('分享结束')
                  },
                })
              }
            },
          })
        })
      }
    })
    .catch((err) => {
      console.log(err)
    })
}
